import {CardInfoContent} from '../../../../components/CardInfoGuide/CardInfoGuide'

const identificationInfo: CardInfoContent = {
  title: 'Guia de Identificação',
  subtitle: 'Entenda o papel dos códigos que identificam esta variação.',
  items: [
    {
      label: 'Variação do Produto / SKU',
      description:
        'Identificador único da variação (Stock Keeping Unit). É o "RG" do produto no estoque.',
    },
    {
      label: 'Gerar SKU',
      description:
        'Botão para criar automaticamente um código baseado nos atributos da variação, como cor e tamanho.',
    },
    {
      label: 'Reference Code',
      description:
        'Código de referência interno, usado para controle do fabricante, fornecedor ou operação interna.',
    },
    {
      label: 'Código da Cor',
      description: 'Identificador numérico ou hexadecimal específico da cor da variação.',
    },
    {
      label: 'GTIN',
      description:
        '(Global Trade Item Number) Código de barras EAN/UPC que identifica o produto de forma global.',
    },
    {
      label: 'MPN',
      description:
        '(Manufacturer Part Number) Código usado pelo fabricante para identificar aquela peça específica.',
    },
    {
      label: 'NCM',
      description:
        '(Nomenclatura Comum do Mercosul) Código fiscal de 8 dígitos usado para classificação tributária.',
    },
  ],
}

const pricesInfo: CardInfoContent = {
  title: 'Guia de Preços',
  subtitle: 'Defina margem, valor de venda e estratégia promocional.',
  items: [
    {
      label: 'Preço de Custo',
      description:
        'Valor pago ao fornecedor. Base para cálculo de margem e análise de rentabilidade.',
    },
    {
      label: 'Preço de Venda',
      description: 'Valor padrão pelo qual a variação será anunciada na loja.',
    },
    {
      label: 'Preço Promocional',
      description:
        'Valor reduzido em campanhas. Quando ativo, a loja pode exibir o formato "de/por".',
    },
  ],
}

const availabilityInfo: CardInfoContent = {
  title: 'Guia de Disponibilidade',
  subtitle: 'Configure prazo e comportamento de venda sem estoque.',
  items: [
    {
      label: 'Disponibilidade do Produto',
      description:
        'Define se o item está pronto para entrega imediata ou se exige prazo de produção/encomenda.',
    },
    {
      label: 'Quando o estoque acabar',
      description: 'Define se o sistema oculta o produto ou continua vendendo sob encomenda.',
    },
  ],
}

const stockInfo: CardInfoContent = {
  title: 'Guia de Estoque',
  subtitle: 'Mantenha saldo e reposição sob controle operacional.',
  items: [
    {
      label: 'Quantidade em Estoque',
      description: 'Número total de unidades físicas disponíveis para venda imediata.',
    },
    {
      label: 'Estoque Mínimo',
      description:
        'Define um limite de segurança para o sistema sinalizar necessidade de reposição.',
    },
  ],
}

const dimensionsInfo: CardInfoContent = {
  title: 'Guia de Dimensões (Logística)',
  subtitle: 'Dados físicos usados no cálculo de frete e embalagem.',
  items: [
    {
      label: 'Peso / Altura / Largura / Profundidade',
      description:
        'Informações utilizadas pelo sistema de frete para calcular custo de envio e tipo de embalagem.',
    },
  ],
}

const attributesInfo: CardInfoContent = {
  title: 'Guia de Atributos da Variação',
  subtitle: 'Combinações de atributos geram variações únicas de produto.',
  items: [
    {
      label: 'Tamanho / Cor / Modelo',
      description:
        'São os filtros que o cliente seleciona. Ex.: "P", "Vermelho", "Baby Look". Cada combinação cria uma variação única.',
    },
  ],
}

const statusInfo: CardInfoContent = {
  title: 'Guia de Status',
  subtitle: 'Controle exibição da variação e regras de preço promocional.',
  items: [
    {
      label: 'Status (Ativo/Inativo)',
      description: 'Controla se a variação fica visível e disponível para compra na loja.',
    },
    {
      label: 'Exibir Preço Promocional',
      description: 'Ativa ou desativa a exibição do valor promocional na vitrine da loja.',
    },
  ],
}

export {
  identificationInfo,
  pricesInfo,
  availabilityInfo,
  stockInfo,
  dimensionsInfo,
  attributesInfo,
  statusInfo,
}
